module.exports = __webpack_public_path__ + "static/media/erste-hilfe.a452766a.jpg";